// eslint-disable-next-line jira/import/no-anonymous-default-export
export default [
	// Regex groups: addonKey, pageKey
	/\/plugins\/servlet\/ac\/(.+)\/([^?\s]+)/i,
];
